/**
 * WbChip — klein betekenis-label naast een nummer of naam.
 *
 * klacht   rood: klacht / herbehandeling
 * actie    rood: actie nodig (klant zegt nee, betaling open)
 * klaar    groen: klaar / akkoord / afgeleverd
 * wacht    oranje: wacht op klant of kantoor
 * neutraal wit met inktrand: soort, lijst, status zonder lading
 * nu       mint: nieuw / nu (zelfde semantiek als WbFlag 'nieuw')
 */

import clsx from 'clsx';

export interface WbChipProps {
  kind?: 'klacht' | 'actie' | 'klaar' | 'wacht' | 'neutraal' | 'nu';
  children: React.ReactNode;
  className?: string;
}

const STIJL: Record<NonNullable<WbChipProps['kind']>, string> = {
  klacht: 'bg-wb-geld text-wb-geldink',
  actie: 'bg-wb-geld text-wb-geldink',
  klaar: 'bg-wb-afleveren text-wb-inkt',
  wacht: 'bg-wb-opmerking text-wb-inkt',
  neutraal: 'bg-wb-vlak text-wb-inkt border border-wb-rand',
  nu: 'bg-wb-mint text-wb-mintink',
};

export function WbChip({ kind = 'neutraal', children, className }: WbChipProps) {
  return (
    <span className={clsx('inline-flex items-center text-[11px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded-[4px] whitespace-nowrap', STIJL[kind], className)}>
      {children}
    </span>
  );
}
